<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-detalles-solicitudes-inscripciones-programa-universidad"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      :rowSelection="rowSelection"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :isRowSelectable="isRowSelectable">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro, cellRendererSiONo } from '../utils/funciones';
import Boton4HistorialEstadosAcademicos from './Boton4HistorialEstadosAcademicos.vue';

export default {
  name: 'ListadoDetallesSolicitudesInscripciones',
  mixins: [listadoAgGridMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Boton4HistorialEstadosAcademicos,
  },
  props: {
    rowSelection: {
      type: String,
      default: 'single',
      validator: (value) => ['single', 'multiple'].includes(value),
    },
    itemsYaSeleccionados: {
      type: Array,
      default: () => [],
    },
    sonPagosUniversidad: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.isRowSelectable = (params) => {
      return (
        !!params.data &&
        !this.itemsYaSeleccionados.some((item) => item.detalleSolicitudPagoId === params.data.id) &&
        !params.data.detallePagoUniversidad
      );
    };

    if (this.sonPagosUniversidad) {
      this.columnDefs.splice(4, 0, {
        headerName: 'ESTA PAGADO',
        cellRenderer: cellRendererSiONo('detallePagoUniversidad', 'PAGADO', 'NO PAGADO'),
        filter: false,
        minWidth: 130,
        maxWidth: 130,
      });

      this.gridApi?.refreshCells({ force: true });
    }
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          minWidth: 130,
          maxWidth: 130,
        },
        {
          headerName: 'N° DOCUMENTO',
          field: 'estudiante.numeroDocumento',
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: (params) => {
            const estado = params.data?.estado?.toUpperCase();

            return estado;
          },
          filter: false,
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'ESTADO ACADÉMICO',
          cellRenderer: 'Boton4HistorialEstadosAcademicos',
          valueGetter: (params) => {
            const estadoAcademico = params?.data?.estadoAcademico || '-';

            window.console.log(params?.data);

            return estadoAcademico;
          },
          filter: true,
          minWidth: 250,
          maxWidth: 250,
        },
        {
          headerName: 'PRIMER APELLIDO',
          field: 'estudiante.primerApellido',
          minWidth: 180,
        },
        {
          headerName: 'SEGUNDO APELLIDO',
          field: 'estudiante.segundoApellido',
          minWidth: 180,
        },
        {
          headerName: 'NOMBRES',
          field: 'estudiante.nombres',
          minWidth: 200,
        },
        {
          headerName: 'GÉNERO',
          cellRenderer: (params) => {
            const genero = params?.data?.estudiante?.sexo;

            return genero === 'M' ? 'MASCULINO' : 'FEMENINO';
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CELULAR',
          cellRenderer: (params) => {
            const estudiante = params?.data?.estudiante;
            const celular = estudiante?.telefono1 || estudiante?.telefono2;

            return celular || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'CORREO',
          cellRenderer: (params) => {
            const correo = params?.data?.estudiante?.email;

            return correo || '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'PROFESIÓN',
          cellRenderer: (params) => {
            const profesiones = params?.data?.estudiante?.profesiones;

            return profesiones?.length ? profesiones[0].nombre : '-';
          },
          minWidth: 250,
        },
        {
          headerName: 'UNIV. TITULACIÓN',
          cellRenderer: (params) => {
            const universidad = params?.data?.estudiante?.institucion?.nombre;

            return universidad || '-';
          },
          minWidth: 450,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 180,
          maxWidth: 180,
        },
      ],
    };
  },
  methods: {
    onSelectionChanged() {
      this.selectedRows = this.gridApi.getSelectedRows();

      if (this.rowSelection === 'single') {
        this.$emit('selectItem', this.selectedRows.length > 0 ? this.selectedRows[0] : null);
      } else {
        this.$emit('selectItem', this.selectedRows);
      }
    },
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-detalles-solicitudes-inscripciones-programa-universidad {
  height: calc(var(--vh, 1vh) * 100 - 24rem);
}
</style>
  